import { faFile, faFileAlt, faPrint, faSave, faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, MenuItem, Pagination, Select, Skeleton, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Page from '../../component/Page'
import api from '../../api/api'
import dayjs from 'dayjs'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useSelector } from 'react-redux'
import { MobileDatePicker } from '@mui/x-date-pickers'
import RequireField from '../../component/RequireField'
const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : ''} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function ReceiptList() {
    // const [branchsNo, setBranchsNo] = useState('all')
    const { profile } = useSelector(state => state.profile)
    const [searchParams, setSearchParams] = useSearchParams()
    let q = searchParams.get('q') || ''
    let branchsNo = searchParams.get('b') || 'all'
    let id = searchParams.get('id') || ''
    let page = searchParams.get('page') || '1'
    let date = searchParams.get('date') || null
    const [data, setData] = useState([])
    const [branchs, setBranchs] = useState([])
    const [doi, setDoi] = useState('')
    const [doiError, setDoiError] = useState(false)
    const [loading, setLoading] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const navigate = useNavigate()
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);

    };
    const handleDialogSubmit = () => {
        const postData = async () => {
            setLoadingSubmit(true)
            const res = await api.post(`sale/receipts`, {
                DoiNo: doi
            }
            )
            const data = await res.data
            if (data.status === true) {
                Swal.fire(
                    'ทำรายการสำเร็จ',
                    '',
                    'success'
                )
                setLoadingSubmit(false)
                setOpen(false)
                getData()
                setSearchParams({ date: null, q: '', b: 'all' })
                setDoi('')
            } else {
                Swal.fire(
                    'ทำรายการไม่สำเร็จ',
                    '',
                    'error'
                )
                setLoadingSubmit(false)

            }
        }
        if (doi) {
            postData()
        } else {
            setDoiError(true)
        }
    }

    const handleClose = () => {
        setOpen(false);
        setDoiError(false)
        setDoi('')
    };
    const getData = async () => {
        setLoading(true)
        const res = await api.get(`sale/receipts?doiNo=${q}&branchNo=${branchsNo === 'all' ? '' : branchsNo || profile?.BranchNo?.BranchNo}&sdate=${date !== 'null' && date !== null ? date : ''}&edate=${date !== 'null' && date !== null ? date : ''}&page=${page}&limit=${rowsPerPage}`)
        const data = await res.data.result
        if (res.data.status === true) {
            setData(data)
            setLoading(false)
        }
    }
    const getBranchs = async () => {
        const res = await api.get(`dbms/branchs`)
        const data = await res.data.result
        if (res.data.status === true) {
            setBranchs(data)
        }
    }

    useEffect(() => {
        getBranchs()
    }, [])
    useEffect(() => {
        if (profile) {
            getData()
        }

    }, [branchsNo, page, q, date, profile])


    async function downloadFile(doiNo) {
        const item = data.items.map((x, i) => ({
            ...x,
            loading: doiNo === x?.DoiNo && true
        }))
        setData({ ...data, items: item })
        const convertDoiNo = encodeURIComponent(doiNo)
        const res = await api.get('sale/receipts' + `/${convertDoiNo}/pdf`, {
            responseType: 'arraybuffer'
        })
        const buffer = res.data
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        const itemf = data.items.map((x, i) => ({
            ...x,
            loading: doiNo === x?.DoiNo && false
        }))
        setData({ ...data, items: itemf })
    }


    return (
        <Page>
            <div class="card-content mt-4">
                <div class="container-fluid">

                    <div class=" d-flex row justify-content-between align-items-baseline">
                        <div class="col-lg-3 col-md-12 text-left ">
                            <label class="title-content mb-4">
                                รายการใบเสร็จ
                            </label>
                        </div>
                        <div class="col-lg-9 col-md-12 text-left " style={{ display: 'flex', justifyContent: 'end' }}>
                            {/* <div class="col-lg-3 col-md-12 text-end px-4">
                                <Button onClick={() => handleClickOpen()} className="ButtomSearch" variant='contained'>+ เพิ่มรายการ</Button>
                            </div > */}
                            {profile?.BranchNo?.BranchNo === '00' &&
                                <div class="col-lg-3 col-md-12 ">
                                    <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                                        <FormControl variant="standard" fullWidth >
                                            <Select value={branchsNo || 'all'} onChange={e => setSearchParams({ b: e.target.value, q: q, date: date })}
                                                disableUnderline
                                                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                            >
                                                <MenuItem value='all'>ทั้งหมด</MenuItem>

                                                {branchs?.map((x, i) => (
                                                    <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </div>
                            }
                            <div class="col-lg-3 col-md-12 ">

                                <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                                    <MobileDatePicker
                                        dayOfWeekFormatter={(day) => `${day}`}
                                        value={date ? dayjs(date) : ''} onChange={e => setSearchParams({ date: dayjs(e).format('YYYY-MM-DD'), q: q, b: branchsNo })}
                                        slotProps={{ textField: { variant: 'standard', placeholder: 'วันที่ออกใบเสร็จ', fullWidth: true, InputProps: { disableUnderline: true }, value: date === 'null' ? '' : date ? dayjs(date) : '' } }}
                                        slots={{
                                            textField: BrowserInput,
                                        }}
                                    />
                                    {date !== 'null' && date !== null && <span style={{ cursor: 'pointer' }} onClick={() => setSearchParams({ date: null, q: q, b: branchsNo })}>X</span>}
                                </Box>
                            </div>
                            <div class="col-lg-3 col-md-12">
                                <Box className='backgroundField'>
                                    <TextField value={q} onChange={e => setSearchParams({ q: e.target.value, b: branchsNo, date: date })} variant="standard" fullWidth placeholder="ค้นหา เลขที่เอกสาร"
                                        InputProps={{
                                            disableUnderline: true,
                                            startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                        }}
                                    />
                                </Box>
                            </div>
                        </div>
                    </div>

                    <div class="listData row">
                        {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                            <div class="col-md-12 table-responsive-sm pb-3">
                                <table class="table table-borderless table-hover ">
                                    <thead>
                                        <tr>
                                            <th class="text-center">ที่</th>
                                            <th class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                            <th class="text-center">เลขที่ DOI</th>
                                            <th class="text-center">วันที่</th>
                                            <th class="text-center" style={{ width: "300px" }}>ชื่อผู้ซื้อ</th>
                                            <th class="text-center">ประเภทผู้ซื้อ</th>
                                            <th class="text-center">เลขที่ใบเสร็จ</th>
                                            <th class="text-center">เล่มที่</th>
                                            <th class="text-center">สถานะ</th>
                                            <th class="text-center">สถานะการพิมพ์</th>
                                            <th class="text-center"></th>
                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        {data?.items?.map((x, i) => (
                                            <tr class="cp" style={{ cursor: 'pointer', backgroundColor: id === x?.AdjustNo ? 'rgb(204, 204, 204) !important' : '' }} >
                                                <td class="text-center" onClick={() => {
                                                    navigate(`/sale/coppy-list/${encodeURIComponent(x.DoiNo)}`)
                                                }}> {(data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i}</td>
                                                <td class="text-center" onClick={() => navigate(`/receipt/receipt-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.BranchName}</td>
                                                <td class="text-center" onClick={() => navigate(`/receipt/receipt-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.DoiNo}</td>
                                                <td class="text-center" onClick={() => navigate(`/receipt/receipt-list/${encodeURIComponent(x.DoiNo)}`)}>{dayjs(x?.DocumentDate).format('DD/MM/BBBB')}</td>
                                                <td class="text-center" style={{
                                                    maxWidth: "400px", whiteSpace: 'break-spaces',
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: "3",
                                                    minHeight:'57px',
                                                    maxHeight:"78px",
                                                    overflow: "hidden",
                                                }} onClick={() => navigate(`/receipt/receipt-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.CustomerName}</td>
                                                <td class="text-center" onClick={() => navigate(`/receipt/receipt-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.CustomerTypeName}</td>
                                                <td class="text-center" onClick={() => navigate(`/receipt/receipt-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.ReceiptNo}</td>
                                                <td class="text-center" onClick={() => navigate(`/receipt/receipt-list/${encodeURIComponent(x.DoiNo)}`)}>{x?.BatchNo}</td>
                                                <td class="text-center" onClick={() => navigate(`/receipt/receipt-list/${encodeURIComponent(x.DoiNo)}`)}>
                                                    {x.Status === 'Y' ?
                                                        <span class="status-active">
                                                            ปกติ
                                                        </span> : <span class="status-inactive">
                                                            ยกเลิก
                                                        </span>}
                                                </td>
                                                <td class="text-center" onClick={() => navigate(`/receipt/receipt-list/${encodeURIComponent(x.DoiNo)}`)}>
                                                    {x?.DownloadStatus}
                                                </td>
                                                <td class="text-center">
                                                    <div>
                                                        {/* {x?.Status === 'Y' && <Button onClick={() => downloadFile(x.DoiNo)} variant='outlined' startIcon={<FontAwesomeIcon icon={faPrint} />} sx={{ width: '120px', padding: "6px 10px", fontSize: '12px' }}>Download</Button>} */}
                                                        {x?.Status === 'Y' && <Button onClick={() => downloadFile(x.DoiNo)} variant='outlined' startIcon={<FontAwesomeIcon icon={faPrint} />} sx={{ width: '120px', padding: "6px 10px", fontSize: '12px' }}>{x?.loading ? <CircularProgress size={'18px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>}
                                                        {/* {x?.Status === 'Y' && profile?.BranchNo?.BranchNo === '00' ? <Button onClick={() => CancelDoi(x.DoiNo)} variant='outlined' color='error' sx={{ width: '110px', marginLeft: '10px', padding: "6px 10px", fontSize: '12px' }}>ยกเลิก</Button> : null}  */}
                                                    </div>

                                                </td>


                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>}
                        <div class="col-md-12 text-center mt-4">
                            <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={data?.meta?.totalPages} page={+page} onChange={(event, value) => setSearchParams({ page: value, q: q, b: branchsNo, date: date })} shape="rounded" />
                        </div>
                    </div>
                </div>
            </div>
            <Dialog fullWidth maxWidth='sm' open={open}>
                <DialogTitle id="alert-dialog-title">เพิ่มรายการ</DialogTitle>
                <DialogContent>
                    <label class="labelInput">เลขที่ DOI</label>
                    <RequireField value={doi} onChange={setDoi} type={'text'} error={doiError} setError={setDoiError} textError={'กรุณากรอกเลขที่ DOI'} />
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' onClick={handleClose}>ยกเลิก</Button>
                    <Button disabled={loadingSubmit} variant='contained' onClick={handleDialogSubmit}>{loadingSubmit ? <CircularProgress size={'18px'} color="inherit" /> : 'ยืนยัน'}</Button>
                </DialogActions>
            </Dialog>
        </Page>
    )
}
